import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import styled from 'styled-components';
import classNames from 'classnames';
import styles from './textTruncate.styles';
const Div = styled.div `
  ${styles}
`;
const TextTruncate = ({ text, charLimit = 270, readMoreText = 'Read more', readLessText = 'Read less', }) => {
    const [isTruncated, setIsTruncated] = useState(true);
    const toggleTruncate = () => {
        setIsTruncated(!isTruncated);
    };
    return (_jsx(Div, { className: classNames({ collapsed: isTruncated, expanded: !isTruncated }), children: _jsxs("p", { children: [isTruncated ? text.substring(0, charLimit) + (text.length > charLimit ? '...' : '') : text, text.length > charLimit && (_jsx("span", { className: "read-more-less-button", onClick: toggleTruncate, children: isTruncated ? readMoreText : readLessText }))] }) }));
};
export default TextTruncate;
